import {CustomsPackingCode, CustomsPackingProblemType} from "@/model/HqPackingListModels";
import {ContainerTypeModel} from "@/model/ContainerType";

export class HenganLoadingPlanModel {
  code: string;
  customerAbbreviation: string;
  logisticsSpecialistName: string;
  transshipDelivery: string;
  transshipDeclaration: string;
  state: State;
  hqPackingLists: HqPackingListModel[] = [];
}

export class HqPackingListModel {
  id: string;
  code: string;
  parentId: string;
  parentCode: string;
  factoryName: string;
  remark: string;
  createdAt: Date;
  typ: string;
  state: HqPackingListState;
  deliveryNoteCode: string;
  deliveryNoteId: string;
  customsPackingSet: CustomsPackingModel[] = [];
  unpackedProductInfos: ProductInfoModel[] = [];
  customsPackingGroups: CustomsPackingGroupModel[] = [];
}

export class HqPackingListState {
  name: string;
  desc: string;
  canGetReceiveList: boolean;
}

export class CustomsPackingGroupModel {
  id: string;
  code: CustomsPackingCode;
  checked: boolean;
}

export class CustomsPackingModel {
  id: string;
  code: CustomsPackingCode;
  hqPackingListId: string;
  hqPackingListCode: string;
  packingVolume: PackingVolume;
  packingWeight: PackingWeight;
  state: State;
  ackType: string;
  loadingFirst: boolean;
  createdAt: Date;
  factoryName?: string;
  problemType?: ProblemType;
  secondaryPackingSet: SecondaryPackingModel[] = [];
  groupId?: string;
  cartonNumber?: number;
  descriptions?: string[];
  declarationDescriptions?: string;
  purchaseOrderNumbers?: string;
  bePackagedCustomsPacking: boolean;
  type: string;
  unboxing: boolean;
  inventory: string;
  useInventoryQuantity: number;
  containerNumber: string;
  purchaseOrderExceptionsProcessed: boolean;
  exception: boolean;
  exceptionReason: CustomsPackingProblemType;
}

export class SecondaryPackingModel {
  id: string;
  customsPackingId: string;
  cartonNumber: number;
  cartonCode: string;
  createdAt: Date;
  packingInfos: SecondaryPackingInfoModel[] = [];
}

export class SecondaryPackingInfoModel {
  id: string;
  secondaryPackingId: string;
  packingVolume: PackingVolume;
  packingWeight: PackingWeight;
  productInfos: ProductInfoModel[] = [];
}

export class ProductInfoModel {
  id: string;
  parentId: string;
  description: string;
  declarationDescription: string;
  guestModel: string;
  hqOrJrNumber: string;
  oeNumber: string;
  refNumber: string;
  hqTransactionNumber: string;
  totalNumberPcs: number;
  netWeight: number;
  purchaseOrderNumber: string;
  batch: string;
  unitPrice: number;
  poNumber: string;
  remark: string;
  loadingFirst: boolean;
  createdAt: Date;
}

/**
 * 包装体积
 */
export class PackingVolume {
  length: number;
  width: number;
  height: number;

  calculateVolume(): string {
    const volume = (this.length * this.width * this.height)/1000000;
    return (Math.round(volume * 100) / 100).toFixed(2);
  }

  calculateVolumeNoDecimalProcessing(): string {
    const volume = (this.length * this.width * this.height)/1000000;
    return (Math.round(volume * 10000) / 10000).toFixed(4);
  }

  constructor(length: number, width: number, height: number) {
    this.length = length;
    this.width = width;
    this.height = height;
  }
}

/**
 * 包装重量
 */
export class PackingWeight {
  netWeight: number;
  grossWeight: number;
}

/**
 * 状态
 */
export class State {
  name: string;
  desc: string;
}

/**
 * 装柜信息
 */
export class LoadingInfo {
  id: string;
  containerType: ContainerTypeModel;
  containerTypeId: string;
  containerTypeCode: string;
  containerNumber = "";
  containerName = "";
  sealNumber = "";
  logisticsCompany: string;
  licensePlateNumber: string;
  driverTel: string;
  weight: number;
  remark: string;
  volume: string;
  customsPackingSet: CustomsPackingModel[] = [];
}

/**
 * 主包装异常类型
 */
export class ProblemType {
  name: string;
  desc: string;
}
